import Report from '../model/Report'
import { configuration } from './Configuration'
import NewReport from '../model/NewReport'
import { fetchWithAccessToken } from './SiteConfig-api'

export const ParseDateTime = (key: {}, value: {}) => {
  if (typeof value === 'string') {
    if (
      !value &&
      typeof key === 'string' &&
      (key.toLowerCase().indexOf('date') >= 0 || key.toLowerCase().indexOf('time') >= 0)
    ) {
      return undefined
    }
    try {
      const date = new Date(Date.parse(value))
      if (!isNaN(date.getTime())) {
        return date
      }
    } catch (e) {
      return value
    }
  }
  return value
}

export const loadReportList = (params: {
  market: string
  reportGroup: string
}): Promise<Report[]> =>
  loadReportListFromURL(`${configuration.SmartAPI}reports/${params.market}/${params.reportGroup}`)

const loadReportListFromURL = (url: string): Promise<Report[]> => {
  return fetchWithAccessToken(url, 'SmartApi', {
    method: 'GET',
    credentials: 'include'
  }).then(function(response: Response) {
    if (response.status !== 200) {
      throw response.statusText
    }
    // Convert to JSON
    return response.text().then(json => JSON.parse(json, ParseDateTime))
  })
}

export const downloadReportUrl = (market: string, reportId: number) => {
  return `${configuration.SmartAPI}downloadReport/${market}/${reportId}/`
}

const makePostUrl = (market: string, reportGroup: string, report: NewReport) => {
  var url = `${configuration.SmartAPI}reports/${market}/${reportGroup}?fileName=${report.file.name}`
  if (report.period) {
    url += `&period=${report.period}`
  }
  if (report.startDate) {
    url += `&startDate=${report.startDate}`
  }
  if (report.site) {
    url += `&site=${report.site}`
  }
  return url
}

export const addReport = (params: {
  market: string
  reportGroup: string
  report: NewReport
}): Promise<void> =>
  addReportFromURL(
    makePostUrl(params.market, params.reportGroup, params.report),
    params.report.file
  )

const addReportFromURL = (url: string, file: File): Promise<void> => {
  return fetchWithAccessToken(url, 'SmartApi', {
    method: 'POST',
    body: file,
    credentials: 'include'
  }).then(function(response: Response) {
    if (response.status !== 200) {
      throw response.statusText
    }
  })
}

const makeSpecificReportUrl = (market: string, report: Report) => {
  return `${configuration.SmartAPI}reports/${market}/${report.id}`
}

export const replaceReport = (params: {
  market: string
  report: Report
  file: File
}): Promise<Report> =>
  replaceReportFromURL(makeSpecificReportUrl(params.market, params.report), params.file)

const replaceReportFromURL = (url: string, file: File): Promise<Report> => {
  return fetchWithAccessToken(`${url}?fileName=${file.name}`, 'SmartApi', {
    method: 'PUT',
    body: file,
    credentials: 'include'
  }).then(function(response: Response) {
    if (response.status !== 200) {
      throw response.statusText
    }
    // Convert to JSON
    return response.text().then(json => JSON.parse(json, ParseDateTime))
  })
}

export const deleteReport = (params: { market: string; report: Report }): Promise<void> =>
  deleteReportFromURL(makeSpecificReportUrl(params.market, params.report))

const deleteReportFromURL = (url: string): Promise<void> => {
  return fetchWithAccessToken(url, 'SmartApi', {
    method: 'DELETE',
    credentials: 'include'
  }).then(function(response: Response) {
    if (response.status !== 200) {
      throw response.statusText
    }
  })
}
